import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Appbar from '@material-ui/core/Appbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BrushIcon from '@material-ui/icons/Brush';
import PieChartIcon from '@material-ui/icons/PieChart';
import SportsMotorsportsIcon from '@material-ui/icons/SportsMotorsports';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import WidgetsIcon from '@material-ui/icons/Widgets';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import DigitalArt from './digital-art';
import GraphicDesign from './graphic-design';
import AR from './ar';
import ThreeD from './threed';
import FullStack from './fullstack';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        //display: 'flex',
        minHeight: "100vh",
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
}));

export default function Portfolio() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Appbar style={{ backgroundColor: "white", boxShadow: "none" }} position="sticky">
                <Tabs
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs"
                    indicatorColor="primary"
                    textColor="primary"
                    className={classes.tabs}
                >
                    {/* Digital Art */}
                    <Tab icon={<BrushIcon />} {...a11yProps(0)} />
                    {/* Graphic Design */}
                    <Tab icon={<PieChartIcon />} {...a11yProps(1)} />
                    {/* Augmented Reality */}
                    <Tab icon={<SportsMotorsportsIcon />} {...a11yProps(2)} />
                    {/* 3D Design */}
                    <Tab icon={<ThreeDRotationIcon />} {...a11yProps(3)} />
                    <Tab icon={<WidgetsIcon />} {...a11yProps(4)} />
                </Tabs>
                <Divider />
            </Appbar>   
            <div ></div>         
            <Grid container justify="center">
                <Grid item sm={9} xs={12} >
                    <Box mt={5}>
                        <TabPanel value={value} index={0} >
                            <Typography className="top-tab" variant="h4" component="span">
                                <Box mb={4} id="scroll-to-top-anchor" component="span" textAlign="center" display="block">
                                    Digital Art
                                </Box>
                            </Typography>
                            <DigitalArt />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Typography variant="h4" component="span">
                                <Box component="span" textAlign="center" display="block">
                                    Graphic Design
                                </Box>
                            </Typography>
                            <GraphicDesign />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Typography variant="h4" component="span">
                                <Box component="span" textAlign="center" display="block">
                                    Augmented Reality
                                </Box>
                            </Typography>
                            <AR />
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            <Typography variant="h4" component="span">
                                <Box mb={4} component="span" textAlign="center" display="block">
                                    3D Design
                                </Box>
                            </Typography>
                            <ThreeD />
                        </TabPanel>
                        <TabPanel value={value} index={4}>
                            <Typography variant="h4" component="span">
                                <Box component="span" textAlign="center" display="block">
                                    Fullstack development
                                </Box>
                            </Typography>
                            <FullStack />
                        </TabPanel>
                        </Box>
                </Grid>
            </Grid>
        </div>
    );
}